import { animate, AnimationEvent, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export type TooltipPosition = 'left' | 'right' | 'above' | 'below' | 'before' | 'after';
export type TooltipVisibility = 'initial' | 'visible' | 'hidden';
export type TooltipType = 'default' | 'light';

@Component({
  selector: 'rt-tooltip-inner',
  templateUrl: './tooltip.html',
  styleUrls: ['./tooltip.less'],
  animations: [
    trigger('state', [
      state('void', style({ transform: 'scale(0)' })),
      state('initial', style({ transform: 'scale(0)' })),
      state('visible', style({ transform: 'scale(1)' })),
      state('hidden', style({ transform: 'scale(0)' })),
      transition('* => visible', animate('150ms cubic-bezier(0.0, 0.0, 0.2, 1)')),
      transition('* => hidden', animate('150ms cubic-bezier(0.4, 0.0, 1, 1)')),
    ]),
  ],
  host: {
    '[@state]': 'visibility',
    '[style.transform-origin]': 'transformOrigin',
    '[class]': 'position',
    '[class.light]': `type === 'light'`,
    '[class.has-border]': 'hasBorder',
    '[class.has-shadow]': 'hasShadow',
    '[class.has-no-arrow]': 'hasNoArrow',
    '[class.has-text-align-center]': 'hasTextAlignCenter',
    '(@state.done)': 'handleAfterVisibilityAnimation($event)',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipInnerComponent {
  @Input() public message: string;
  @Input() public templateRef: any;
  @Input() public type: TooltipType = 'default';
  @Input() public hasBorder: boolean;
  @Input() public hasShadow: boolean;
  @Input() public hasNoArrow: boolean;
  @Input() public hasTextAlignCenter: boolean;
  @Input() public visibility: TooltipVisibility = 'initial';
  @Input() public position: TooltipPosition;
  @Input() public transformOrigin: string = 'above';
  @Output() public hide: EventEmitter<void> = new EventEmitter();
  @Output() public animationState = new EventEmitter<AnimationEvent>();

  public isVisible(): boolean {
    return this.visibility === 'visible';
  }

  public handleAfterVisibilityAnimation(event: AnimationEvent): void {
    this.animationState.emit(event);
    if (event.toState === 'hidden' && !this.isVisible()) {
      this.hide.emit();
    }
  }
}
